import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { NewBookingAvailabilityPage } from '../../../../../features/parking/ui/booking-pages/new-booking/NewBookingAvailabilityPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default NewBookingAvailabilityPage;
